import { cookiesTool } from 'react-gdpr'
import { all, put, SagaReturnType, select, takeEvery } from 'redux-saga/effects'

import { actions, selectors } from './redux'
import { actionTypes } from './types'

const isGAIDExist =
  typeof import.meta.env.VITE_GTM_ID === 'string' && import.meta.env.VITE_GTM_ID.length > 0

const transformPageData = (path: any, data: any) => {
  return data
}

export default class TrackingSagas {
  static *onTrackPage({ payload }: actionTypes.trackPage) {
    const { path, ...data } = payload
    const transformedData = transformPageData(path, data)
    const codeEmbedded: SagaReturnType<typeof selectors.codeEmbedded> = yield select(
      selectors.codeEmbedded
    )

    if (!codeEmbedded || !cookiesTool.isActive('analytics') || !isGAIDExist) {
      return
    }

    window.gtag('config', String(import.meta.env.VITE_GTM_ID), {
      cookie_expires: 365 * 24 * 60 * 60,
      page_path: path,
      ...(transformedData && {
        ...transformedData,
      }),
    })
  }
  static *onTrackEvent({ payload }: actionTypes.trackEvent) {
    const { action, category: event_category, label: event_label, ...otherData } = payload
    const codeEmbedded: SagaReturnType<typeof selectors.codeEmbedded> = yield select(
      selectors.codeEmbedded
    )

    if (!codeEmbedded || !cookiesTool.isActive('analytics') || !isGAIDExist) {
      return
    }

    // Send event
    window.gtag('event', action, {
      event_category,
      event_label,
      ...(otherData && {
        ...otherData,
      }),
    })
  }

  static *onEnableTracking() {
    const codeEmbedded: SagaReturnType<typeof selectors.codeEmbedded> = yield select(
      selectors.codeEmbedded
    )

    if (window?.dataLayer) {
      window.dataLayer.push({ event: 'gdpr-consent' })
    }

    if (!codeEmbedded || !cookiesTool.isActive('analytics') || !isGAIDExist) {
      return
    }

    if (codeEmbedded) {
      return
    }

    yield put(actions.setCodeEmbeded())
  }

  static *listeners() {
    yield all([
      //
      takeEvery(actions.trackPage, this.onTrackPage),
      takeEvery(actions.trackEvent, this.onTrackEvent),
      takeEvery(actions.enableTracking, this.onEnableTracking),
      //
    ])
  }
}
